import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setGridData = ({ commit }, data) => {
  commit('SET_GRID_DATA_GRID_SAMPLE', data);
};

const setProjectList = ({ commit }, data) => {
  commit('SET_PROJECT_LIST_GRID_SAMPLE', data);
};
export default {
  async SEARCH_GRID_GRID_SAMPLE(store, param) {
    const searchPeriod = DateUtil.stdFormat(param.searchPeriod);
    param = { ...param, ...searchPeriod };
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/sample/grid/grid-with-paging?${StringUtil.queryStringfy(param)}`);

    setGridData(store, data.data);
  },
  async SEARCH_PROJECT_LIST_GRID_SAMPLE(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/sample/grid/project?${StringUtil.queryStringfy(param)}`);

    setProjectList(store, data.data);
  },
  async UPDATE_EXCEPT_GRID_SAMPLE(store, param) {
    await RequestUtil.put(`${SDLUtil.API_URL}/sample/grid/key-except`, param);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/sample/gridSample/gridSampleAction.js